<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>基础服务</el-breadcrumb-item>
            <el-breadcrumb-item>品牌管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs v-model="activeName" type="card" @tab-click="changeActive">
            <el-tab-pane name="first">
                <span slot="label">品牌管理</span>
            </el-tab-pane>
            <el-tab-pane name="second">
                <span slot="label">待审核</span>
            </el-tab-pane>
        </el-tabs>
        <div class="btns">
            <el-button type="danger" size="small" @click="batchAgree" v-auth="['admin/brand/agree']">批量通过</el-button>
            <el-button type="" size="small" @click="batchRefuse" v-auth="['admin/brand/refuse']">批量驳回</el-button>
        </div>
        <el-table :data="list" border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center"></el-table-column>
            <el-table-column width="60" align="center">
                <template slot-scope="scope">
                    {{scope.$index + (page-1) * pageSize + 1}}
                </template>
            </el-table-column>
            <el-table-column prop="name" label="品牌名称"></el-table-column>
			<el-table-column label="所属供应商">
			    <template slot-scope="scope">
			        {{scope.row.supplier ? scope.row.supplier.name : ''}}
			    </template>
			</el-table-column>
            <el-table-column label="品牌图标">
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                        <img :src="scope.row.logo" height="30" style="display: flex;"/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="授权证书">
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                        <img :src="scope.row.auth_pic" height="30" style="display: flex;"/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="introduction" label="介绍">
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-popconfirm title="您确定要通过这条数据吗？" @confirm="agree(scope.row.id)" class="l10" v-auth="['admin/brand/agree']">
                        <el-button size="mini" type="danger" slot="reference">通过</el-button>
                    </el-popconfirm>
                    <el-button style="margin-left: 10px" size="mini" type="" @click.stop="refuse(scope.row.id)" v-auth="['admin/brand/refuse']">驳回</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list:[],
                isLoad:false,
                pageSize:20,
                total:0,
                page:1,
                multipleSelection:[],
                activeName: 'second'
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            loadList(){
                if(this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/admin/brand/brand_apply',{
                    page: this.page,
                    limit: this.pageSize
                })
                .then(res => {
                    this.isLoad = !this.isLoad
                    // 获取数据
                    this.list = res.data.list.data
                    // 页数 page
                    this.total = res.data.list.total
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            changeActive: function (tab, event) {
                if (this.activeName == 'first') {
                    this.$router.push({
                        path: '/Basics/brand.html',
                    });
                }
            },
            // navigatorTo: function (url) {
            //     console.log(url)
            //     this.$router.push({
            //         path: url,
            //         query:{
            //         }
            //     });
            // },
            // 跳转到edit添加
            add(){
                this.$router.push({path: '/Basics/brandEdit.html'});
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(id){
                this.$router.push({
                    path:'/Basics/brandEdit.html',
                    query:{
                        id:id
                    }
                });
            },
            //
            agree(id){
                if(this.isLoad){
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/brand/agree', {
                    data: {
                        id: id
                    }
                })
                .then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '操作成功',
                        showClose:false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            refuse(id){
                this.$prompt('', '拒绝原因', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    if (!value) {
                        this.$message.success({
                            message: '请输入拒绝原因'
                        });
                        return false;
                    }

                    if(this.isLoad){
                        return
                    }
                    this.isLoad = !this.isLoad
                    this.axios.delete('/admin/brand/refuse', {
                        data: {
                            id: id,
                            reason: value
                        }
                    })
                    .then(() => {
                        this.isLoad = false
                        this.$message.success({
                            message: '操作成功',
                            showClose:false
                        });
                        this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = false
                    })
                }).catch(() => {

                });
            },
            batchAgree: function () {
                let id = []
                for(let key in this.multipleSelection){
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if(id.length == 0) {
                    return
                }
                this.isLoad = true
                this.$confirm('确认审核通过？', '提示', {
                	confirmButtonText: '确定',
                	cancelButtonText: '取消',
                	type: 'info'
                }).then(() => {
                    this.axios.delete('/admin/brand/agree', {
                        data: {
                            id: id
                        }
                    })
                    .then(() => {
                        this.isLoad = false
                        this.$message.success({
                            message: '操作成功',
                            showClose:false
                        });
                        this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = false
                    })
                })
            },
            batchRefuse: function () {
                let id = []
                for(let key in this.multipleSelection){
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }

                if(id.length == 0) {
                    return
                }

                this.$prompt('', '拒绝原因', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    if (!value) {
                        this.$message.success({
                            message: '请输入拒绝原因'
                        });
                        return false;
                    }

                    if(this.isLoad){
                        return
                    }
                    this.isLoad = !this.isLoad
                    this.axios.delete('/admin/brand/refuse', {
                        data: {
                            id: id,
                            reason: value
                        }
                    })
                        .then(() => {
                            this.isLoad = false
                            this.$message.success({
                                message: '操作成功',
                                showClose:false
                            });
                            this.loadList()
                        })
                        .catch(() => {
                            this.isLoad = false
                        })
                }).catch(() => {

                });
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAll(){
                let id = []
                for(let key in this.multipleSelection){
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if(this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/brand/delete', {
                    data: {
                        ids: id
                    }
                }).then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose:false
                    });
                    this.loadList()
                })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },

            sizeReload(val){
                this.pageSize = val
                this.loadList()
            },
            pageReload(val){
                this.page = val
                this.loadList()
            }
        }
    }
</script>
<style scoped>
</style>
